import script from "./manufacture.vue?vue&type=script&setup=true&lang=js"
export * from "./manufacture.vue?vue&type=script&setup=true&lang=js"

import "./manufacture.vue?vue&type=style&index=0&id=3c3fc7ba&lang=scss"

const __exports__ = script;

export default __exports__